import { render, staticRenderFns } from "./SelectorPromo.vue?vue&type=template&id=3d37d6f5&scoped=true"
import script from "./SelectorPromo.vue?vue&type=script&lang=js"
export * from "./SelectorPromo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37d6f5",
  null
  
)

export default component.exports